import { useEffect, useState } from "react";

const clentHintsParam = "kMobileClientHints";

export function DeviceDetector(props) {
  const [canDisplayChildren, setCanDisplayChildren] = useState(false);

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);

    if (sessionStorage.getItem(clentHintsParam)) {
      setCanDisplayChildren(true);
      return;
    }

    if (!searchParams.get(clentHintsParam)) { // Check if not redirect from server
      window.location.href = `${
        process.env.REACT_APP_WEB_API_URL
      }/client-hints?redirectUrl=${encodeURIComponent(window.location.href)}`;
    } else {
      sessionStorage.setItem(clentHintsParam, new Date().getTime());

      searchParams.delete(clentHintsParam);
      const newSearch = searchParams.toString();

      window.location.href = `${window.location.pathname}${
        newSearch ? `?${newSearch}` : ""
      }`;
    }
  }, []);

  return canDisplayChildren ? props.children : null;
}
